// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Geye","colBig":"styles_colBig__WTNGx","colSmall":"styles_colSmall__3wteF","shopifyNameWrapper":"styles_shopifyNameWrapper__7EXlU"};